<script lang="ts" context="module">
	import Modal from "../modal/Modal.svelte";
	import Badge from "./Badge.svelte";
	import BadgeDetails from "./BadgeDetails.svelte";
	import type { MyBadgesQuery } from "$gql/generated";
	type BadgeType = MyBadgesQuery["me"]["badges"][0];
</script>

<script lang="ts">
	export let myBadges: BadgeType[] = [];
	export let notMyBadges: BadgeType[] = [];
	export let hideDescription = false;
	export let isOpen: boolean = false;

	let showAllBadges = false;

	function close() {
		isOpen = false;
	}

	$: allBadges = [...myBadges, ...notMyBadges];
	$: badgesToShow = allBadges.slice(0, 23);
	const badgesPerRowArray = [7, 6, 7];

	function showAllBadgesPopup() {
		showAllBadges = true;
	}
</script>

{#each badgesPerRowArray as badgesPerRow, rowNumber}
	<div class="flex w-full items-center justify-center" class:-mt-2={rowNumber > 0}>
		{#each badgesToShow.splice(0, badgesPerRow) as badge}
			<div class="mb-2 ml-1 mr-1 flex-shrink">
				<Badge {badge} badgeSize="small" active={badge.mine ? true : false} />
			</div>
		{/each}
	</div>
{/each}

{#if !hideDescription}
	<div class="mt-3 flex items-center justify-between">
		<button class="clickable text-base font-medium text-teal-600 hover:underline" on:click={showAllBadgesPopup}> See all badges </button>
	</div>
{/if}

{#if !import.meta.env.SSR}
	<Modal bind:isOpen={showAllBadges} on:close={close} --popup-width="880px" title="Smore badges">
		<i slot="icon" class="material-icons text-nxgray-300">military_tech</i>
		<div class="-mx-5 -mb-5 grid grid-cols-2 flex-wrap items-center justify-start overflow-auto rounded-b-md" style="max-height: 50vh;">
			{#each allBadges as badge}
				<div
					class="badge-wrapper flex h-32 items-center border-b border-r p-4 px-6"
					class:bg-teal-100={myBadges.findIndex((b) => b.name === badge.name) >= 0}>
					<BadgeDetails {badge} />
				</div>
			{/each}
		</div>
	</Modal>
{/if}

<style>
	.badge-wrapper:nth-child(2n) {
		border-right: none;
	}
</style>
